import { mobileQuery, tabQuery } from "../theme";

const customerManagementStyles = {
  welcome: {
    background: "linear-gradient(135deg, #1B2A6B 0%, #243580 45%, #00A9E0 100%)",
    width: "100%",
    position: "relative",
    overflow: "hidden",
    padding: "1.25rem 2rem",
    borderRadius: 16,
    minHeight: 90,
    display: "flex",
    alignItems: "center",
    boxShadow: "0 4px 24px rgba(27,42,107,0.18)",
    [tabQuery]: { padding: "1.5rem 1.75rem" },
    "&::before": {
      content: '""',
      position: "absolute",
      top: "-60px",
      right: "-60px",
      width: "200px",
      height: "200px",
      borderRadius: "50%",
      background: "rgba(255,255,255,0.06)",
      pointerEvents: "none",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: "-220px",
      left: "35%",
      width: "180px",
      height: "180px",
      borderRadius: "50%",
      background: "rgba(0,169,224,0.12)",
      pointerEvents: "none",
    },
    "& img": { display: "none" },
  },
  welcomeContent: {
    position: "relative",
    zIndex: 1,
    flex: 1,
  },
  welcomeTitle: {
    color: "#ffffff",
    fontSize: "1.15rem",
    fontWeight: 700,
    margin: "0 0 0.3rem",
    lineHeight: 1.3,
  },
  welcomeSub: {
    color: "rgba(255,255,255,0.65)",
    fontSize: "0.85rem",
    margin: "0 0 0.5rem",
  },
  welcomeIllustration: {
    position: "absolute",
    right: "2rem",
    bottom: 0,
    height: "100%",
    opacity: 0.15,
    pointerEvents: "none",
    [mobileQuery]: { display: "none" },
  },
  welcomeBtn: {
    "& .ant-btn": {
      color: "rgba(255,255,255,0.9) !important",
      borderColor: "rgba(255,255,255,0.45) !important",
      background: "transparent !important",
      fontWeight: "600 !important",
      borderRadius: "8px !important",
      "&:hover": {
        background: "rgba(255,255,255,0.12) !important",
        borderColor: "rgba(255,255,255,0.7) !important",
        color: "#ffffff !important",
      },
    },
  },
};

export default customerManagementStyles;
